import { useRef, useEffect, type JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import DescriptionIcon from '@mui/icons-material/Description';
import HCaptcha, { type HCaptcha as HCaptchaInstance } from '@hcaptcha/react-hcaptcha';

import { useHcaptcha } from '@footsteps/shared';
import { routes } from '../../../routes';
import { useWozCaseManager } from '../woz-case-manager.provider';
import { WozActiveCaseModal } from '../modals/WozActiveCaseModal';

export const WozCaseManagerStartCase = (): JSX.Element => {
  const { caseManagerState, caseManagerViewModel } = useWozCaseManager();
  const { siteKey } = useHcaptcha();
  const captchaRef = useRef<HCaptchaInstance | null>(null);
  const navigate = useNavigate();

  const { isCaseReady, isFlowComplete } = caseManagerState;

  useEffect(() => {
    if (isCaseReady) {
      caseManagerViewModel.setIsCaseReady(false);
      navigate(isFlowComplete ? routes.summary : routes.intake);
    }
  }, [isCaseReady, isFlowComplete, caseManagerViewModel, navigate]);

  const handleStart = () => {
    caseManagerViewModel.startCase(() => captchaRef.current?.execute());
  };

  return (
    <>
      <Button
        variant='contained'
        startIcon={<DescriptionIcon />}
        onClick={handleStart}
        disabled={caseManagerState.isStartDisabled}
      >
        {caseManagerState.isCreatingCase ? 'Bezig...' : 'Start nieuw WOZ-bezwaar'}
      </Button>
      {!caseManagerState.auth.hasUser && (
        <HCaptcha
          ref={captchaRef}
          sitekey={siteKey}
          size='invisible'
          theme='light'
          languageOverride='nl'
          loadAsync
          onLoad={caseManagerViewModel.setCaptchaReady}
          onReady={caseManagerViewModel.setCaptchaReady}
          onVerify={caseManagerViewModel.onCaptchaVerified}
          onExpire={caseManagerViewModel.onCaptchaError}
          onError={() => {
            caseManagerViewModel.onCaptchaError();
            captchaRef.current?.resetCaptcha();
          }}
        />
      )}
      <WozActiveCaseModal />
    </>
  );
};
